import { useCallback } from 'react';
import { useApiPost } from '@sierralabs/core-ui';
export function useCreateReport() {
    const { data, isLoading, error, post } = useApiPost('reports');
    const createReport = useCallback((dto) => post(dto), [post]);
    return {
        createdReport: data,
        creatingReport: isLoading,
        creatingReportError: error,
        createReport
    };
}
//# sourceMappingURL=useCreateReport.js.map